<template>
  <!--设备在线率 水球图组件-->
  <div>
    <div id="onlineRateChart" style="width: 100%;height:20vh;"></div>
  </div>
</template>

<script>
import 'echarts-liquidfill/src/liquidFill.js';
import {onLineNumber} from "@/api/home"; //在这里引入
export default {
  name: "onlineRate",
  data() {
    return {
      onLineNumberData: {
        offline: [],
        online: [],
      },
      myChart: null,
      option: {
        graphic: [
          {
            type: 'group',
            left: '22%',
            top: '33%',
            children: [{
              type: 'text',
              z: 100,
              left: 'center',
              top: '10',
              style: {
                fill: '#fff',
                text: '在线',
                font: '14px Microsoft YaHei'
              }
            },
            ]
          },
          {
            type: 'group',
            left: '67%',
            top: '33%',
            children: [{
              type: 'text',
              z: 100,
              left: 'center',
              top: '25',
              style: {
                fill: '#fff',
                text: '离线',
                font: '14px Microsoft YaHei'
              }
            },
            ]
          }
        ],
        series: [
          {
            type: 'liquidFill',
            waveAnimation: false, //停止动画 动画占用cpu过高
            // animationDuration: 0,
            // animationDurationUpdate: 0,
            data: [],
            radius: '75%',//水求图大小
            // 水球颜色
            color: ['#49d088', '#38b470', '#2aaf66'],
            center: ['25%', '50%'],
            // outline  外边
            outline: {
              // show: false
              borderDistance: 0,
              itemStyle: {
                borderWidth: 2,
                borderColor: '#13FDCE',
              },
            },
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  insideColor: 'yellow',
                  fontSize: 30,//百分比的字体大小
                  text: '',
                  top: '20%'
                }
              }
            },
            // 内图 背景色 边
            backgroundStyle: {
              color: 'rgba(4,24,74,0.8)',
              // borderWidth: 5,
              // borderColor: 'red',
            }
          },
          {
            type: 'liquidFill',
            waveAnimation: false, //停止动画 动画占用cpu过高
            // animationDuration: 0,
            // animationDurationUpdate: 0,
            data: [],
            radius: '75%',//水求图大小
            // 水球颜色
            color: ['#FE5555', '#F07581', '#FB5E61'],
            center: ['70%', '50%'],
            // outline  外边
            outline: {
              // show: false
              borderDistance: 0,
              itemStyle: {
                borderWidth: 2,
                borderColor: '#FE5555',
              },
            },
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  insideColor: 'yellow',
                  fontSize: 30,//百分比的字体大小
                  text: '',
                  top: '20%'
                }
              }
            },
            // 内图 背景色 边
            backgroundStyle: {
              color: 'rgba(4,24,74,0.8)',
              // borderWidth: 5,
              // borderColor: 'red',
            }
          }]
      },
      respondData:{
        offlineRate:'',
        onlineRate:''
      },//存储接口的相应数据
      timer:null
    }
  },
  mounted() {
    this.getData()
    this.timer = setInterval(() => {
      this.getData()
    },2000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    init() {
      this.myChart = this.$echarts.init(document.getElementById('onlineRateChart'));
      this.option.series[0].data = this.onLineNumberData.online || [];
      this.option.series[1].data = this.onLineNumberData.offline || [];
      this.myChart.setOption(this.option);
    },
    getData() {
      onLineNumber({
        jsessionId: sessionStorage.token,
      }).then(res => {
        if (res.data.code === 0) {
          if(this.respondData.offlineRate != res.data.data.offlineRate || this.respondData.onlineRate != res.data.data.onlineRate ){
            this.respondData = {
              offlineRate:res.data.data.offlineRate,
              onlineRate:res.data.data.onlineRate,
            }
            let data = {
              offline: res.data.data.offlineRate.replace('%', '') / 100,
              online: res.data.data.onlineRate.replace('%', '') / 100
            }
            this.onLineNumberData = {
              offline: this.turnOnLineNumber(data.offline),
              online: this.turnOnLineNumber(data.online),
            }
            this.init()
          }
        }
      })
    },
    turnOnLineNumber(data) {
      let arr = []
      if (data > 0) {
        if (data > 0.4) {
          arr = [data, data - 0.1, data - 0.2, data - 0.3]
        } else if (data > 0.2 && data < 0.4) {
          arr = [data, data - 0.05, data - 0.1, data - 0.15]
        } else {
          arr = [data, data, data, data]
        }
      } else {
        arr = [0, 0, 0, 0]
      }
      return arr;
    },
    resizeChart() {
      this.myChart.resize()
    }
  }
}
</script>

<style scoped>

</style>
